export default "__VITE_ASSET__D8wV_BJ2__"